import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode } from "vue"

import DictCodeSelect from '@/components/common/DictCodeSelect.vue'
import { computed, onMounted, reactive, ref, toRef, watch } from 'vue'
import { DictCodeOptions } from '@/types'
import { getDeptDict, getDictCodes } from '@/api/common'
import { ERR_SUCCESS } from '@/api/config'
import { useStore } from 'vuex'
import { ElMessage } from 'element-plus/lib'


export default /*#__PURE__*/_defineComponent({
  __name: 'SelectOptions',
  props: {
  codesIn: { type: String, required: true },
  multiple: { type: Boolean, default: false }
},
  emits: ['changeSelect'],
  setup(__props, { emit: __emit }) {

const store = useStore()

const userInfo = toRef(store.getters.userInfo)
const deptValue = ref([])

// 检查 dept 是否设置并处理默认值
function checkDept() {
  if (!userInfo.value.dept) {
    console.log('用户信息中没有设置 dept')
    return false
  }
  return true
}

const selectCodes = reactive<{ [key: string]: string }>({
  platform: '',
  subject: '',
  edition: '',
  period: '',
  grade: '',
  year: '',
  term: '',
  papertype: '',
  questype: ''
})

const dictCodeOptions = reactive<DictCodeOptions>({
  platform: { label: '平台', value: '', data: [] },
  subject: { label: '学科', value: '', data: [] },
  edition: { label: '版本', value: '', data: [] },
  period: { label: '学段', value: '', data: [] },
  grade: { label: '年级', value: '', data: [] },
  year: { label: '年份', value: '', data: [] },
  term: { label: '学期', value: '', data: [] },
  papertype: { label: '类型', value: '', data: [] },
  questype: { label: '类型', value: '', data: [] }
})

const props = __props

const emit = __emit

const filteredOptions = computed(() => {
  const result: typeof dictCodeOptions = {}
  for (const [key, option] of Object.entries(dictCodeOptions)) {
    if (option.data && option.data.length > 0) {
      result[key] = option
    }
  }
  return result
})
async function fetchData() {
  try {
    const { code, result: dictCodes } = await getDictCodes(props.codesIn)
    if (code === ERR_SUCCESS && dictCodes) {
      for (const dictCode of dictCodes) {
        const key = dictCode.code as keyof typeof dictCodeOptions
        if (dictCodeOptions[key]) {
          dictCodeOptions[key].data = dictCodes
            .filter(dc => dc.code === dictCode.code)
            .map(dc => {
              if (dc.label === deptValue.value[0] || dc.label === deptValue.value[1]) {
                deptValue.value[deptValue.value.indexOf(dc.label)] = dc.value
              }
              return { value: dc.value, label: dc.label }
            })
        }
      }

      // Only assign to selectCodes if deptValue has values
      if (deptValue.value.length > 0) {
        selectCodes.period = deptValue.value[0]
        selectCodes.subject = deptValue.value[1]
      } else {
        // Provide default values if deptValue is empty
        selectCodes.period = ''
        selectCodes.subject = ''
      }
    }
  } catch (error) {
    console.error('Error fetching dictionary codes:', error)
  }
}

function findNamePath(data, targetId, path = []) {
  for (const item of data) {
    if (item.id === targetId) {
      return [...path, item.name]
    }
    if (item.children) {
      const result = findNamePath(item.children, targetId, [...path, item.name])
      if (result) return result
    }
  }
  return null
}

onMounted(async () => {
  if (checkDept()) {
    try {
      const response = await getDeptDict()
      if (response.code === 2000 && response.result) {
        deptValue.value = findNamePath(response.result, userInfo.value.dept) || []
      }
    } catch (error) {
      console.error('Failed to load department data:', error)
    }
  }
  await fetchData()
})

watch(selectCodes, () => {
  emit('changeSelect', selectCodes)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredOptions.value, (option, index) => {
    return (_openBlock(), _createElementBlock("div", {
      key: index,
      class: "option-item"
    }, [
      _createVNode(DictCodeSelect, {
        modelValue: selectCodes[index],
        "onUpdate:modelValue": ($event: any) => ((selectCodes[index]) = $event),
        multiple: __props.multiple,
        options: option.data,
        placeholder: '请选择' + option.label
      }, null, 8, ["modelValue", "onUpdate:modelValue", "multiple", "options", "placeholder"])
    ]))
  }), 128))
}
}

})